import React, { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ApiData } from "../api";
import { ISetting } from "../types";

export const TextContext = createContext({} as { data: ISetting });

const TextContextProvider = ({ children }) => {
  const [data, upload] = useState({});

  useEffect(() => {
    ApiData.settings().then((data) => {
      if (!data) return;
      upload(data);
    });
  }, []);

  return (
    // @ts-ignore
    <TextContext.Provider value={{ data }}>{children}</TextContext.Provider>
  );
};

TextContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TextContextProvider;
